import { stripSamiJourneyBlocksFromContent } from "./conciergeJourney";

/** Fenced blocks parsed elsewhere (e.g. side panels); hide from chat markdown view. */
const PM_STRUCTURED_BLOCK_RE = /```pm-entity-(?:action|list)\s*[\s\S]*?```/gi;

const INTEGRATION_STRUCTURED_BLOCK_RE =
  /```integration-(?:code-review|certification-checklist|product-context|code-samples|escalation|code-import)\s*[\s\S]*?```/gi;

const ARCHITECT_STRUCTURED_BLOCK_RE =
  /```(?:architect-review|api-description|architecture-standard|intake-evaluation)\s*[\s\S]*?```/gi;

const PRODUCTION_SUPPORT_STRUCTURED_BLOCK_RE =
  /```(?:operational-error-extraction|sop-guide-import|production-support-triage)\s*[\s\S]*?```/gi;

export type AgentStructuredBlockPreset =
  | "product-manager"
  | "integration"
  | "architect"
  | "production-support"
  | "concierge";

/**
 * Removes structured JSON fences from agent text before markdown rendering.
 * Raw message content in state is unchanged so parsers still work.
 */
export function stripStructuredBlocksForDisplay(
  content: string,
  preset?: AgentStructuredBlockPreset,
): string {
  let text = content;
  if (preset === "product-manager") {
    text = text.replace(PM_STRUCTURED_BLOCK_RE, "");
  } else if (preset === "integration") {
    text = text.replace(INTEGRATION_STRUCTURED_BLOCK_RE, "");
  } else if (preset === "architect") {
    text = text.replace(ARCHITECT_STRUCTURED_BLOCK_RE, "");
  } else if (preset === "production-support") {
    text = text.replace(PRODUCTION_SUPPORT_STRUCTURED_BLOCK_RE, "");
  } else if (preset === "concierge") {
    return stripSamiJourneyBlocksFromContent(text);
  }
  return text.replace(/\n{3,}/g, "\n\n").trim();
}
